import { RadioGroup, RadioGroupItem } from '@utilities-one/gpm-ui';

import { FormBase } from '@/library/form/components/FormBase';
import { useFieldContext } from '@/library/form/contexts';
import { FormControlProps, SelectOption } from '@/library/form/types/form.type';

type FormRadioProps = FormControlProps & {
  options: SelectOption[];
  disabled?: boolean;
};

export function FormRadio({ options, disabled, ...props }: FormRadioProps) {
  const field = useFieldContext<string>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

  return (
    <FormBase {...props}>
      <RadioGroup
        value={String(field.state.value)}
        disabled={disabled}
        onValueChange={field.handleChange}
        onBlur={field.handleBlur}
        className="flex flex-row gap-4"
        aria-invalid={isInvalid}
      >
        {options.map((opt) => (
          <div key={opt.value} className="flex items-center gap-2">
            <RadioGroupItem value={opt.value} id={`${field.name}-${opt.value}`} />
            <label htmlFor={`${field.name}-${opt.value}`} className="text-sm">
              {opt.label}
            </label>
          </div>
        ))}
      </RadioGroup>
    </FormBase>
  );
}
